/** Design tokens for auth screens (Brushfire Theme 1 — aligned with web-sensemaker). */
export const palettePrimaryMain = '#008CD0'
export const paletteErrorMain = '#EF4444'
export const paletteSuccessMain = '#10B981'
/** Figma 5074-11486 / 5074-12076 / 5074-11995 — page canvas (rgb 248,249,255) */
export const surfaceAuthCanvas = '#F8F9FF'
/** Figma auth cards / top bar — explicit #FFFFFF, not theme paper */
export const surfaceAuthCard = '#FFFFFF'

/** Centered verification card — force opaque white (ld-102); merge into card `sx`. */
export const authCardSurfaceSx = {
  bgcolor: surfaceAuthCard,
  backgroundColor: surfaceAuthCard,
  backgroundImage: 'none',
} as const

/** OutlinedInput root + states — Figma auth fields #FFFFFF (ld-111); blocks MUI hover grey. */
export const authOutlinedInputSurfaceSx = {
  bgcolor: surfaceAuthCard,
  backgroundColor: surfaceAuthCard,
  backgroundImage: 'none',
  '&:hover': {
    bgcolor: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
    backgroundImage: 'none',
  },
  '&.Mui-focused': {
    bgcolor: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
    backgroundImage: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
    backgroundImage: 'none',
  },
  '&.Mui-error': {
    bgcolor: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
    backgroundImage: 'none',
  },
} as const
export const textPrimary = '#23262F'
export const textSecondary = '#061E32'
export const textMuted = '#65758B'
export const borderInput = '#EDEDED'
export const borderInputFocus = '#E1E7F3'

/** Figma 5074-12188 / 5074-11759 — split-screen Signal Provider login */
export const authMarketingPanelBg = '#04183F'
export const authHeadingSlate = '#0F172A'
export const authDescriptionSlate = '#64748B'
export const authRememberLabel = '#3D3D3D'
/** Figma 5074-11761 / 5074-11764 — top + bottom chrome (not page canvas) */
export const authFooterBg = surfaceAuthCard
export const authFooterBorder = '#E2E8F0'
export const authTopBarBorder = '#F1F5F9'
export const authInvalidEmailBorder = '#FF5959'
